import * as React from "react";
import {useIntl} from "react-intl";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faChevronRight} from "@fortawesome/pro-regular-svg-icons";
import {monthToDate} from "../../../helper/analysisMonths";

type MonthRangeHeaderProps = {
    from: string // YYYY-MM
    to: string // YYYY-MM
    canShiftForward: boolean
    onShift: (delta: number) => void
};

/**
 * The headline of the analysis views over twelve months: the months shown, with buttons to move
 * the range by one month.
 */
const MonthRangeHeader: React.FC<MonthRangeHeaderProps> = ({from, to, canShiftForward, onShift}) => {
    const intl = useIntl();
    const formatMonth = (month: string) => intl.formatDate(monthToDate(month), {month: 'long', year: 'numeric', timeZone: 'UTC'});

    return (
        <div className="flex flex-wrap items-center justify-between gap-3">
            <h2 className="text-lg font-medium text-gray-900">
                {intl.formatMessage({id: 'component.analysis.range'}, {from: formatMonth(from), to: formatMonth(to)})}
            </h2>
            <div className="flex items-center gap-1">
                <button type="button" onClick={() => onShift(-1)} className="px-3 py-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100" title={intl.formatMessage({id: 'component.analysis.previousMonth'})}>
                    <FontAwesomeIcon icon={faChevronLeft} className="h-4 w-4"/>
                </button>
                <button type="button" onClick={() => onShift(1)} disabled={!canShiftForward} className="px-3 py-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 disabled:text-gray-300 disabled:cursor-not-allowed disabled:hover:bg-transparent" title={intl.formatMessage({id: 'component.analysis.nextMonth'})}>
                    <FontAwesomeIcon icon={faChevronRight} className="h-4 w-4"/>
                </button>
            </div>
        </div>
    );
};

export default MonthRangeHeader;
